export class ConstantContactCustomField {

    constructor(
        public customFieldId: string,
        public value: string
    ){}
}
